import React, { memo } from 'react';
import { useWtrSelector } from 'redux/hooks';
import ContentLocation from 'components/ContentLocation/ContentLocation';
import { getExperienceFragmentLocation } from 'redux/modules/experience-fragments/selectors';

type ExperienceFragmentProps = {
  experienceFragmentKey: string;
  locationName: string;
};

const ExperienceFragment = ({ experienceFragmentKey, locationName }: ExperienceFragmentProps) => {
  const locationData = useWtrSelector((state: WtrState) =>
    getExperienceFragmentLocation(state, experienceFragmentKey, locationName),
  );

  return <ContentLocation childComponents={locationData} name={locationName} />;
};

export default memo(ExperienceFragment);
